import * as React from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { RootState } from '../../reducers';
import { Checkbox } from './checkbox';
import { AmountSelector } from './amountSelector';

export namespace Popup{
	export interface Props extends RouteComponentProps<void> {
		closeModal: (e:any)=>void;
		element: JSX.Element;
	}

	export const Element: React.SFC<Popup.Props> = (props) => {
		return(
			<div>
				<div className="am_popupheader">
					<p className="am_inline col-6"><b>{/*Uuden opetusryhmän lisääminen*/}</b></p>
					<img onClick={props.closeModal} style={{cursor: 'pointer'}} className="am_smallicon float-right" src="/images/CrossButton.png"/>
				</div>
				{props.element}
			</div>
		);
	}

	export interface Input {
		preElement?: JSX.Element,
		afterElement?: JSX.Element,
		value?: string,
		width?: number,
		placeholder?: string,
		disabled?: boolean,
		required?: boolean,
		name: string,
		type: string,
	}

	export interface Button {
		image: string,
		text: string
	}

	export namespace Form{
		export interface Props extends RouteComponentProps<void>{
			inputs: Popup.Input[];
			buttons: Popup.Button[];
			accept: (values: any)=>void;
			cancel?: (e: any)=>void;
		}
	}

	export class Form extends React.Component<Popup.Form.Props>{
	
		private inputelements: object;

		constructor(props){
			super(props);
			this.inputelements = {};
		}

		submitForm(e: any){
			let values = {};
			for(let key in this.inputelements){
				values[key] = this.inputelements[key].value || this.inputelements[key];
			}
			console.log("VALUES HERE ", values);
			this.props.accept(values);
		}

		render(){
			let inputDOMS = [];
			for(let i = 0; i < this.props.inputs.length; i++){
				let input = this.props.inputs[i];
				let inputname = input.name;

				let inputDOM = [];

				if (input.preElement) inputDOM.push(input.preElement);
				
				if (input.type === "checkbox") {
					this.inputelements[input.name] = false;
					inputDOM.push(<Checkbox onChange={(e)=>{this.inputelements[input.name] = e.target.checked}} id={""+i} name={input.name} noFloat={true} checked={this.inputelements[input.name]} disabled={input.disabled}/>);
				}
				else if (input.type === "amountselector") {
					if(input.value)
						this.inputelements[input.name] = parseInt(input.value);
					inputDOM.push(<AmountSelector id={""+i} onChange={(value: number)=>{this.inputelements[input.name] = value}} defaultValue={parseInt(input.value)||0} disabled={input.disabled} />);
				}
				else {
					let placeholder = "" || input.placeholder;
					inputDOM.push(<input ref={(inputref)=>{this.inputelements[inputname] = inputref}} type={input.type} name={input.name} placeholder={placeholder} defaultValue={input.value} disabled={input.disabled} required={input.required}/>);
				}
				
				if(input.afterElement)
					inputDOM.push(input.afterElement);

				inputDOMS.push(<div className={"col-" + (input.width || "12")}>{inputDOM}</div>);
			}

			for(let i = 0; i < this.props.buttons.length; i++){
				let button = this.props.buttons[i];

				inputDOMS.push(<div className="col-12"><button type="submit" className="btn am_green-button am_shadow am_input am_popupbutton"><img className="am_smallicon" src={button.image}/>{button.text}</button></div>);
			}

			return(
				<div>
					<form className="row" onSubmit={this.submitForm.bind(this)}>
						{inputDOMS}	
					</form>
				</div>
			);
		}
	}

	export const modalStyle = {
		content: {
			backgroundColor: '#D5E3F0',
			borderRadius: '10px',
			bottom: 'auto'
		}
	};
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/containers/Common/popup.tsx